import axios from 'axios';
//export const BASE_URL = 'https://localhost:7028'; //localhost
//export const BASE_URL = 'https://swastikhmsbetest.agsapplications.com'; //test server
export const BASE_URL = 'https://swastikhmsprodbe.agsapplications.com'; //production server

export const axiosOpen = axios.create({
    baseURL: BASE_URL
});

export const axiosAuth = axios.create({
    baseURL: BASE_URL,
    headers: { ContentType: 'application/json' },
    withCredentials: true
});
